const STORAGE_KEYS = {
  AUTH_CONFIG: 'AUTH_CONFIG',
  ORIGIN_URL: 'IMPERSONATION_ORIGIN_URL',
} as const;

export const AUTH_CONFIG_VALUES = {
  IMPERSONATION: 'IMPERSONATION',
  MEMBER: 'MEMBER',
} as const;

const ALLOWED_ORIGIN_DOMAINS = [
  'salesforce.com',
  'force.com',
  'cigna.com',
  'healthspring.com',
] as const;

function isAllowedOriginUrl(url: string): boolean {
  try {
    const parsedUrl = new URL(url);
    return ALLOWED_ORIGIN_DOMAINS.some(
      (domain) =>
        parsedUrl.hostname === domain ||
        parsedUrl.hostname.endsWith(`.${domain}`),
    );
  } catch {
    return false;
  }
}

export function isImpersonationSession(): boolean {
  return (
    localStorage.getItem(STORAGE_KEYS.AUTH_CONFIG) ===
    AUTH_CONFIG_VALUES.IMPERSONATION
  );
}

export function getImpersonationOriginUrl(): string | null {
  if (!isImpersonationSession()) {
    return null;
  }
  return localStorage.getItem(STORAGE_KEYS.ORIGIN_URL);
}

export function startImpersonationSession(originUrl?: string | null): boolean {
  localStorage.setItem(
    STORAGE_KEYS.AUTH_CONFIG,
    AUTH_CONFIG_VALUES.IMPERSONATION,
  );

  if (originUrl && isAllowedOriginUrl(originUrl)) {
    localStorage.setItem(STORAGE_KEYS.ORIGIN_URL, originUrl);
    return true;
  }

  localStorage.removeItem(STORAGE_KEYS.ORIGIN_URL);
  return false;
}

export function endImpersonationSession(): void {
  localStorage.setItem(STORAGE_KEYS.AUTH_CONFIG, AUTH_CONFIG_VALUES.MEMBER);
  localStorage.removeItem(STORAGE_KEYS.ORIGIN_URL);
}

export function getLogoutReturnUrl(fallbackUrl: string): string {
  const originUrl = getImpersonationOriginUrl();
  return originUrl || fallbackUrl;
}
